import React, { useState } from "react";
import {
    FormControlLabel,
    ListItemText,
} from "@mui/material";
import Button from "components/CustomButtons/Button";
import PropTypes from "prop-types";
import GridItem from "components/Grid/GridItem";
import GridContainer from "components/Grid/GridContainer";
import { AddCircleOutline } from "@mui/icons-material";
import List from "@mui/material/List";
import uuid from "react-uuid";
import { makeStyles } from "@mui/styles";
import CustomSelect from "components/Input/CustomSelect.js";
import advancedSearchStyle from "assets/jss/material-dashboard-pro-react/components/advancedSearchStyle";
import LineCondition from "components/Search/LineCondition";
import styled from "styled-components";


const Notabene = styled.div`
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 10px;
  opacity: 1;
`;


const searchStyle = makeStyles(advancedSearchStyle);

function AdvancedSearch(props) {

    const { filters, handleFiltersChange, type, setType, ruletype } = props;
    const [active, setActive] = useState("");
    const conditionAnd = 'Et';
    const conditionOr = 'Ou';

    const addingAndCondition = () => {
        const id = uuid();
        const obj = {
            "item": "",
            "comparator": '',
            "value": '',
            "id": id,
            "itemChanged": true,
        };
        let newFilters = { ...filters };
        newFilters.and.push(obj);
        handleFiltersChange(newFilters);
    }

    const removeAndCondition = (id) => {
        let newFilters = { ...filters };
        const remove = newFilters.and;
        remove.find((o, i) => {
            if (o.id === id) {
                remove.splice(i, 1);
                return true;
            }
            return false;
        });
        newFilters.and = remove;
        handleFiltersChange(newFilters);
    }

    const addingOrCondition = () => {
        const id = uuid();
        const obj = {
            "item": "",
            "comparator": '',
            "value": '',
            "id": id,
            "itemChanged": true,
        };
        let newFilters = { ...filters };
        newFilters.or.push(obj);
        handleFiltersChange(newFilters);
    }

    const removeOrCondition = (id) => {
        let newFilters = { ...filters };
        const remove = newFilters.or;
        remove.find((o, i) => {
            if (o.id === id) {
                remove.splice(i, 1);
                return true;
            }
            return false;
        });
        newFilters.or = remove;
        handleFiltersChange(newFilters);
    }

    const handleTypeChange = (event) => {
        setType(event.target.value);
        let newFilters = { and: [], or: [] };
        handleFiltersChange(newFilters);
    };

    const handleConditionChange = () => {
        let newFilters = { ...filters };
        handleFiltersChange(newFilters);
    }

    const typedata = [
        { name: "Compte client", id: "4.0" },
        { name: "Site", id: "1.0" },
        { name: "Bâtiment", id: "2.0" },
        { name: "Zone", id: "3.0" },
        { name: "Equipement urbain", id: "2.1" },
        { name: "Commune", id: "0.0" },
        { name: "EPCI", id: "0.1" },
        { name: "Groupe", id: "0.2" },
    ];
    const classes = searchStyle();
    return (
        <div>


            <GridContainer>
                {
                    ruletype == 0 ?
                        <GridItem xs={12} sm={12}>
                            <Notabene>NB : Les filtres ne seront pas pris en compte dans le cas de l'utilisation du type de donnée "Points de donnée"</Notabene>
                        </GridItem> : <></>
                }
                <GridItem xs={12} sm={12}>
                    <CustomSelect
                        inputTitle={'Type de groupe'}
                        selectValue={type}
                        handleSelectValueChange={handleTypeChange}
                        data={typedata}
                    />
                </GridItem>
            </GridContainer>
            {type !== '4.0' ?
                <>
                    <GridContainer>
                        <GridItem xs={12} sm={12}>
                            <List component={"nav"}>
                                <ListItemText className={classes.listItemText}> Les groupes doivent remplir toutes ces conditions </ListItemText>

                                {
                                    filters?.and?.map((condition) => {
                                        return (
                                            <LineCondition
                                                key={condition.id} id={condition.id} obj={condition}
                                                removeCondition={() => removeAndCondition(condition.id)}
                                                whichCondition={conditionAnd}
                                                handleConditionChange={handleConditionChange}
                                                type={type}
                                            ></LineCondition>
                                        );
                                    })
                                }
                            </List>

                            <FormControlLabel
                                value="addCondition"
                                className={classes.formControlLabel}
                                control={
                                    <Button
                                        type="button" round
                                        color="transparent"
                                        justIcon size={"sm"}
                                        onClick={addingAndCondition}
                                    >
                                        <AddCircleOutline> </AddCircleOutline>
                                    </Button>
                                }
                                label=" Ajouter une condition "
                            />
                        </GridItem>
                    </GridContainer>

                    <GridContainer>
                        <GridItem xs={12} sm={12}>
                            <List component={"nav"}>
                                <ListItemText className={classes.listItemText}> Les groupes doivent remplir au moins une condition </ListItemText>
                                {
                                    filters?.or?.map((condition) => {
                                        return (
                                            <LineCondition
                                                key={condition.id} id={condition.id} obj={condition}
                                                removeCondition={() => removeOrCondition(condition.id)}
                                                whichCondition={conditionOr}
                                                handleConditionChange={handleConditionChange}
                                                type={type}
                                            ></LineCondition>
                                        );
                                    })
                                }
                            </List>
                            <FormControlLabel
                                value="addCondition"
                                className={classes.formControlLabel}
                                control={
                                    <Button type="button" round color="transparent" justIcon size={"sm"}
                                        onClick={addingOrCondition}
                                    >
                                        <AddCircleOutline> </AddCircleOutline>
                                    </Button>
                                }
                                label=" Ajouter une condition"
                            />
                        </GridItem>
                    </GridContainer>
                </> : <></>}
        </div>
    );

}
export default AdvancedSearch;

AdvancedSearch.propTypes = {
    open: PropTypes.bool,
    handleHideAdvancedSearch: PropTypes.func,
    handleHideAllModal: PropTypes.func,
    getAdvancedResultTree: PropTypes.func,
}